import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../services/alert.service';
import { BookService } from '../../services/book.service';
import { ConfigService } from '../../services/config.service';


@Component({
  selector: 'app-share-study',
  templateUrl: './share-study.component.html',
  styleUrls: ['./share-study.component.css']
})
export class ShareStudyComponent implements OnInit {

  @Input() opened = false;
  mail: string = '';

  //@Input() mail!: string;
  @Output('sendMail') sendMailEmitter = new EventEmitter<string>();
  @Output('downloadInstructions') downloadEmitter = new EventEmitter<void>();


  showMail: boolean = false;
  showQR: boolean = false;

  urlBook = window.location.href;

  urlTotal: string = window.location.href
  urlReadable: string = (environment.demo) ? 'dominio.del.cliente' :  window.location.hostname + window.location.pathname

  locator?: string

  environment = environment;

  constructor(
    private alertService: AlertService,
    public bookService: BookService,
    public configService: ConfigService) { }

  ngOnInit(): void {
  }

  open(locator: string) {
    this.mail = '';
    this.locator = locator;
    this.opened = true;
  }

  close() {
    this.showMail = false;
    this.showQR = false;

    this.opened = false;
  }

  sendMail() {
    if (this.mail == null || this.mail.trim() == '') {
      this.alertService.alert('Por favor, introduzca un correo electrónico');
    } else {
      this.sendMailEmitter.emit(this.mail);
      this.close();
    }
  }


  showMailInput() {
    if (this.showMail == true) {
      this.showMail = false;
    } else {
      this.showMail = true;
      this.showQR = false;
    }
  }

  showQRImg() {
    if (this.showQR == true) {
      this.showQR = false;
    } else {
      this.showQR = true;
      this.showMail = false;
    }
  }

  downloadStudy() {
    this.downloadEmitter.emit();
    this.close();
  }

  copyURL() {
    navigator.clipboard.writeText(this.urlTotal).then(() => {
      this.alertService.toast('Enlace copiado al portapapeles');
    }).catch(err => {
      console.error('Error al copiar el enlace: ', err);
      this.alertService.alert('Error al copiar el enlace');
    });
  }


}
